import { render, staticRenderFns } from "./BreakoutGroupEditor.vue?vue&type=template&id=3e3602e4&scoped=true&"
import script from "./BreakoutGroupEditor.vue?vue&type=script&lang=js&"
export * from "./BreakoutGroupEditor.vue?vue&type=script&lang=js&"
import style0 from "./BreakoutGroupEditor.vue?vue&type=style&index=0&id=3e3602e4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e3602e4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VCol,VIcon,VRow,VTooltip})
